/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dispatch, SetStateAction } from 'react';

import TableComponent from '../../../components/TableComponent';

type props = {
  columns: any;
  rows: any;
  hidden: string[];
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
};

const NewStoreListings = ({ rows, columns, hidden }: props) => {
  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item: any) => !hidden.includes(item.field))}
          rows={rows}
        />
      </div>
    </>
  );
};

export default NewStoreListings;
